/**
 * 인쇄부 유형 열거형
 * - 각 인쇄부에 따라 다른 UI 및 속성 설정
 */
export enum PrintUnitType {
  FRONT = 'FRONT', // 인쇄부 1: 전면 커버 (mm)
  SIDE = 'SIDE', // 인쇄부 2: 측면 (mm)
  BACK_TOP = 'BACK_TOP', // 인쇄부 3: 뒷면 상단 (mm)
  BACK = 'BACK', // 인쇄부 4: 뒷면 (mm)
  DISC2 = 'DISC2', // 인쇄부 5: 디스크 본체 2 (mm)
  DISC_SIDE = 'DISC_SIDE' // 인쇄부 6: 디스크 측면 (mm)
}

/**
 * 텍스트 방향 열거형
 */
export enum TextDirection {
  HORIZONTAL = 'HORIZONTAL', // 가로 출력
  VERTICAL = 'VERTICAL' // 세로 출력
}

/**
 * 텍스트 정렬 방식 열거형
 */
export enum TextAlignment {
  LEFT = 'LEFT', // 좌측 정렬
  CENTER = 'CENTER', // 중앙 정렬
  RIGHT = 'RIGHT' // 우측 정렬
}

/**
 * 모서리 처리 방식 열거형
 */
export enum CornerStyle {
  NONE = 'NONE', // 처리 없음
  ROUND = 'ROUND', // 라운드 처리
  DIAGONAL = 'DIAGONAL' // 사선 처리
}

/**
 * 디스크 본체 디스플레이 모드 열거형
 */
export enum DiscDisplayMode {
  ALBUM_COVER_ONLY = 0, // 앨범 자켓만 표시
  ALBUM_WITH_TRACKLIST = 1 // 앨범 자켓 + 곡 리스트
}

/**
 * 곡 리스트 열 배치 방식 열거형 (인쇄부 4용)
 */
export enum ColumnLayoutType {
  AUTO = 'AUTO', // 곡 수에 따라 자동 — 10곡 이하 1열, 11~16곡 2열 균등, 17곡+ 2열 좌선
  SINGLE_COLUMN = 'SINGLE_COLUMN', // 1열 정렬
  TWO_COLUMN_EQUAL = 'TWO_COLUMN_EQUAL', // 2열 정렬 - 좌우 균등 분배
  TWO_COLUMN_LEFT_PRIORITY = 'TWO_COLUMN_LEFT_PRIORITY', // 2열 정렬 - 좌측 우선
  TWO_COLUMN_RIGHT_PRIORITY = 'TWO_COLUMN_RIGHT_PRIORITY' // 2열 정렬 - 우측에 마지막 절반 정순 표시
}